import { dateToServer } from 'helpers/formatters/date';
import { CalculationFrequency } from 'modules/BenchmarkForm';
import { BenchmarkTypes } from 'types/Benchmark';
import {
  CompositeWeightedLineItem,
  CompositeWeightedTimeWindow,
} from 'types/CompositeWeighted';

const mapTimeWindow = (data: CompositeWeightedTimeWindow) => {
  const {
    fromDate,
    assetSelectionSetId,
    tagRefPropertyDefinitionId,
    tagIds,
    lineItems,
  } = data;

  const timeWindow: CompositeWeightedTimeWindow = {
    fromDate: dateToServer(new Date(fromDate)),
    assetSelectionSetId: Number(assetSelectionSetId),
    tagRefPropertyDefinitionId,
    tagIds,
    lineItems: lineItems.map((lineItem) => {
      const li: CompositeWeightedLineItem = {
        isLagged: lineItem.isLagged,
        customLagDate: lineItem.customLagDate,
        defaultLagDate: lineItem.defaultLagDate,
      };

      if (
        typeof lineItem.returnComponentResourceId === 'string' &&
        lineItem.returnComponentResourceId.includes('-')
      ) {
        li.returnComponentBenchmarkId = lineItem.returnComponentResourceId;
      } else {
        li.returnComponentResourceId = Number(
          lineItem.returnComponentResourceId
        );
      }

      li.weightingComponentTagId = lineItem.weightingComponentTagId;
      return li;
    }),
  };

  return timeWindow;
};

const parseBoolean = (value: string | boolean): boolean => {
  switch (typeof value) {
    case 'string':
      return JSON.parse(value);

    case 'boolean':
    default:
      return value;
  }
};

export function getBody(originalValues: any, newValues: any) {
  const timeWindows = newValues.timeWindows
    ? newValues.timeWindows.map(mapTimeWindow)
    : [];

  return {
    id: originalValues?.id,
    name: newValues.name,
    typeId: BenchmarkTypes.CompositeWeighted,
    calculationFrequencyId:
      newValues.calculationFrequency?.id ?? newValues.calculationFrequencyId,
    baseCurrencyCode: newValues.baseCurrencyCode,
    weightingMethodologyId:
      newValues.weightingMethodology?.id ?? newValues.weightingMethodologyId,
    portfolioAnalyticsCalendarId:
      newValues.calculationFrequencyId === CalculationFrequency.day ||
        newValues.calculationFrequency?.id === CalculationFrequency.day
        ? newValues.portfolioAnalyticsCalendarId
        : undefined,
    includeBookedValues: parseBoolean(newValues.includeBookedValues)
      ? true
      : false,
    useDailyToMonthlyLinking: parseBoolean(newValues.useDailyToMonthlyLinking)
      ? true
      : false,
    performanceVariationCode: newValues.performanceVariationCode,
    timeWindows,
    isLagged: parseBoolean(newValues.isLagged) ? true : false,
    customLagDate: newValues.customLagDate || null,
    description: newValues.description,
    pushTimeWindowsToPortfolioAnalytics: newValues.pushTimeWindowsToPortfolioAnalytics,
    lookThroughDepth: newValues.lookThroughDepth
  };
}
